/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AsyncTransfer = {
  transferID: string;
  createdOn: Date;
};

/** @internal */
export const AsyncTransfer$inboundSchema: z.ZodType<
  AsyncTransfer,
  z.ZodTypeDef,
  unknown
> = z.object({
  transferID: z.string(),
  createdOn: z.string().datetime({ offset: true }).transform(v => new Date(v)),
});
/** @internal */
export type AsyncTransfer$Outbound = {
  transferID: string;
  createdOn: string;
};

/** @internal */
export const AsyncTransfer$outboundSchema: z.ZodType<
  AsyncTransfer$Outbound,
  z.ZodTypeDef,
  AsyncTransfer
> = z.object({
  transferID: z.string(),
  createdOn: z.date().transform(v => v.toISOString()),
});

export function asyncTransferToJSON(asyncTransfer: AsyncTransfer): string {
  return JSON.stringify(AsyncTransfer$outboundSchema.parse(asyncTransfer));
}
export function asyncTransferFromJSON(
  jsonString: string,
): SafeParseResult<AsyncTransfer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AsyncTransfer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AsyncTransfer' from JSON`,
  );
}
